
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4efpo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1e1f94344c8d27fc4c7fb696b371a5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31446c098d89963a$var$_react = $31446c098d89963a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $31446c098d89963a$var$_iconNew = $31446c098d89963a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $31446c098d89963a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-locked
 * Usage guidance:
 * Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31446c098d89963a$var$LockLockedIcon = (props)=>/*#__PURE__*/ $31446c098d89963a$var$_react.default.createElement($31446c098d89963a$var$_iconNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$31446c098d89963a$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $31446c098d89963a$var$_default = module.exports.default = $31446c098d89963a$var$LockLockedIcon;

});

parcelRegister("kTb7m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3519173ee3ab621$var$_react = $f3519173ee3ab621$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f3519173ee3ab621$var$_iconNew = $f3519173ee3ab621$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f3519173ee3ab621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3519173ee3ab621$var$LinkIcon = (props)=>/*#__PURE__*/ $f3519173ee3ab621$var$_react.default.createElement($f3519173ee3ab621$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$f3519173ee3ab621$var$LinkIcon.displayName = 'LinkIcon';
var $f3519173ee3ab621$var$_default = module.exports.default = $f3519173ee3ab621$var$LinkIcon;

});

parcelRegister("24dy7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18167717f357f922$var$_react = $18167717f357f922$var$_interopRequireDefault((parcelRequire("cozmU")));

var $18167717f357f922$var$_iconNew = $18167717f357f922$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $18167717f357f922$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18167717f357f922$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $18167717f357f922$var$_react.default.createElement($18167717f357f922$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$18167717f357f922$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $18167717f357f922$var$_default = module.exports.default = $18167717f357f922$var$StatusErrorIcon;

});

parcelRegister("eDtFr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f20400a5f6ff94df1dafee093c930a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa7bb8833890e3e9$var$_react = $aa7bb8833890e3e9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $aa7bb8833890e3e9$var$_iconNew = $aa7bb8833890e3e9$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $aa7bb8833890e3e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment
 * Usage guidance:
 * Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa7bb8833890e3e9$var$CommentIcon = (props)=>/*#__PURE__*/ $aa7bb8833890e3e9$var$_react.default.createElement($aa7bb8833890e3e9$var$_iconNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$aa7bb8833890e3e9$var$CommentIcon.displayName = 'CommentIcon';
var $aa7bb8833890e3e9$var$_default = module.exports.default = $aa7bb8833890e3e9$var$CommentIcon;

});

parcelRegister("c8bBH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf16aaf4f527b16412d3cee1290b8294>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d4f3c496cc9cf1a$var$_react = $8d4f3c496cc9cf1a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8d4f3c496cc9cf1a$var$_iconNew = $8d4f3c496cc9cf1a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8d4f3c496cc9cf1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/thumbs-up
 * Usage guidance:
 * Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d4f3c496cc9cf1a$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $8d4f3c496cc9cf1a$var$_react.default.createElement($8d4f3c496cc9cf1a$var$_iconNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$8d4f3c496cc9cf1a$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $8d4f3c496cc9cf1a$var$_default = module.exports.default = $8d4f3c496cc9cf1a$var$ThumbsUpIcon;

});

parcelRegister("f6cdQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::674db590f296a2f756724d798fd052ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afe0e5a9ac90e226$var$_react = $afe0e5a9ac90e226$var$_interopRequireDefault((parcelRequire("cozmU")));

var $afe0e5a9ac90e226$var$_iconNew = $afe0e5a9ac90e226$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $afe0e5a9ac90e226$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afe0e5a9ac90e226$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $afe0e5a9ac90e226$var$_react.default.createElement($afe0e5a9ac90e226$var$_iconNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$afe0e5a9ac90e226$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $afe0e5a9ac90e226$var$_default = module.exports.default = $afe0e5a9ac90e226$var$ArrowUpIcon;

});

parcelRegister("kyJuy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef7a45534bb85a98$var$_react = $ef7a45534bb85a98$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ef7a45534bb85a98$var$_iconNew = $ef7a45534bb85a98$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ef7a45534bb85a98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef7a45534bb85a98$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $ef7a45534bb85a98$var$_react.default.createElement($ef7a45534bb85a98$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$ef7a45534bb85a98$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $ef7a45534bb85a98$var$_default = module.exports.default = $ef7a45534bb85a98$var$QuestionCircleIcon;

});

parcelRegister("6YkHb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe170e3e7b80264b949b54a1ecf34342>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5138665ad140aeeb$var$_react = $5138665ad140aeeb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5138665ad140aeeb$var$_iconNew = $5138665ad140aeeb$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $5138665ad140aeeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/angle-brackets
 * Usage guidance:
 * Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5138665ad140aeeb$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $5138665ad140aeeb$var$_react.default.createElement($5138665ad140aeeb$var$_iconNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$5138665ad140aeeb$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $5138665ad140aeeb$var$_default = module.exports.default = $5138665ad140aeeb$var$AngleBracketsIcon;

});

parcelRegister("lSw2p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90fbd5da1cedf8ab72cfec6643bf73aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fed77e25d57348e4$var$_react = $fed77e25d57348e4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fed77e25d57348e4$var$_iconNew = $fed77e25d57348e4$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $fed77e25d57348e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/subtasks
 * Usage guidance:
 * Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fed77e25d57348e4$var$SubtasksIcon = (props)=>/*#__PURE__*/ $fed77e25d57348e4$var$_react.default.createElement($fed77e25d57348e4$var$_iconNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$fed77e25d57348e4$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $fed77e25d57348e4$var$_default = module.exports.default = $fed77e25d57348e4$var$SubtasksIcon;

});

parcelRegister("gFEZF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c230462e1de8a32e$var$_react = $c230462e1de8a32e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c230462e1de8a32e$var$_iconNew = $c230462e1de8a32e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c230462e1de8a32e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c230462e1de8a32e$var$AddIcon = (props)=>/*#__PURE__*/ $c230462e1de8a32e$var$_react.default.createElement($c230462e1de8a32e$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$c230462e1de8a32e$var$AddIcon.displayName = 'AddIcon';
var $c230462e1de8a32e$var$_default = module.exports.default = $c230462e1de8a32e$var$AddIcon;

});

parcelRegister("6Ec6w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d92d6da68cdb4ac3639231927c6c671>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d6fde27879cb25d$var$_react = $4d6fde27879cb25d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4d6fde27879cb25d$var$_iconNew = $4d6fde27879cb25d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4d6fde27879cb25d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app
 * Usage guidance:
 * Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d6fde27879cb25d$var$AppIcon = (props)=>/*#__PURE__*/ $4d6fde27879cb25d$var$_react.default.createElement($4d6fde27879cb25d$var$_iconNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$4d6fde27879cb25d$var$AppIcon.displayName = 'AppIcon';
var $4d6fde27879cb25d$var$_default = module.exports.default = $4d6fde27879cb25d$var$AppIcon;

});

parcelRegister("f922E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15752cbf5c5b8ff3e6a05bbcbc7d40d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b06947b90529d7e4$var$_react = $b06947b90529d7e4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b06947b90529d7e4$var$_iconNew = $b06947b90529d7e4$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b06947b90529d7e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-left
 * Usage guidance:
 * Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b06947b90529d7e4$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $b06947b90529d7e4$var$_react.default.createElement($b06947b90529d7e4$var$_iconNew.default, Object.assign({
        name: "AlignTextLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$b06947b90529d7e4$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $b06947b90529d7e4$var$_default = module.exports.default = $b06947b90529d7e4$var$AlignTextLeftIcon;

});

parcelRegister("31le2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbc55b289fd8663f3e14bee84adcd7ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2331ee09a21bd16d$var$_react = $2331ee09a21bd16d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2331ee09a21bd16d$var$_iconNew = $2331ee09a21bd16d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2331ee09a21bd16d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/archive-box
 * Usage guidance:
 * Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2331ee09a21bd16d$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $2331ee09a21bd16d$var$_react.default.createElement($2331ee09a21bd16d$var$_iconNew.default, Object.assign({
        name: "ArchiveBoxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$2331ee09a21bd16d$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $2331ee09a21bd16d$var$_default = module.exports.default = $2331ee09a21bd16d$var$ArchiveBoxIcon;

});

parcelRegister("fS8Zl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a417dd35c32223c531e68a3b3a9c2a91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8e2df17607a076a$var$_react = $b8e2df17607a076a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b8e2df17607a076a$var$_iconNew = $b8e2df17607a076a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b8e2df17607a076a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-down
 * Usage guidance:
 * Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8e2df17607a076a$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $b8e2df17607a076a$var$_react.default.createElement($b8e2df17607a076a$var$_iconNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$b8e2df17607a076a$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $b8e2df17607a076a$var$_default = module.exports.default = $b8e2df17607a076a$var$ArrowDownIcon;

});

parcelRegister("lepke", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4043daf294edfb6e9fedbae382cffb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f74e8cd914706891$var$_react = $f74e8cd914706891$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f74e8cd914706891$var$_iconNew = $f74e8cd914706891$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f74e8cd914706891$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/commit
 * Usage guidance:
 * Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f74e8cd914706891$var$CommitIcon = (props)=>/*#__PURE__*/ $f74e8cd914706891$var$_react.default.createElement($f74e8cd914706891$var$_iconNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$f74e8cd914706891$var$CommitIcon.displayName = 'CommitIcon';
var $f74e8cd914706891$var$_default = module.exports.default = $f74e8cd914706891$var$CommitIcon;

});

parcelRegister("3fO5l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23389d96ad47534eee0427de6a1854fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e99fae56322efa$var$_react = $25e99fae56322efa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25e99fae56322efa$var$_iconNew = $25e99fae56322efa$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25e99fae56322efa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-bulleted
 * Usage guidance:
 * Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e99fae56322efa$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $25e99fae56322efa$var$_react.default.createElement($25e99fae56322efa$var$_iconNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$25e99fae56322efa$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $25e99fae56322efa$var$_default = module.exports.default = $25e99fae56322efa$var$ListBulletedIcon;

});

parcelRegister("824lD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d91e20a6027b278$var$_react = $5d91e20a6027b278$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5d91e20a6027b278$var$_iconNew = $5d91e20a6027b278$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $5d91e20a6027b278$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d91e20a6027b278$var$CalendarIcon = (props)=>/*#__PURE__*/ $5d91e20a6027b278$var$_react.default.createElement($5d91e20a6027b278$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5d91e20a6027b278$var$CalendarIcon.displayName = 'CalendarIcon';
var $5d91e20a6027b278$var$_default = module.exports.default = $5d91e20a6027b278$var$CalendarIcon;

});

parcelRegister("iZMIZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd43b8338afe33bc$var$_react = $dd43b8338afe33bc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dd43b8338afe33bc$var$_iconNew = $dd43b8338afe33bc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dd43b8338afe33bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd43b8338afe33bc$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $dd43b8338afe33bc$var$_react.default.createElement($dd43b8338afe33bc$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$dd43b8338afe33bc$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $dd43b8338afe33bc$var$_default = module.exports.default = $dd43b8338afe33bc$var$CheckCircleIcon;

});

parcelRegister("7sJoX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56ee5db7894e511f$var$_react = $56ee5db7894e511f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $56ee5db7894e511f$var$_iconNew = $56ee5db7894e511f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $56ee5db7894e511f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56ee5db7894e511f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $56ee5db7894e511f$var$_react.default.createElement($56ee5db7894e511f$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$56ee5db7894e511f$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $56ee5db7894e511f$var$_default = module.exports.default = $56ee5db7894e511f$var$ChevronDownIcon;

});

parcelRegister("iW7aI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea16940a5b16b575a448de9712a73f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc9334eed5a95313$var$_react = $dc9334eed5a95313$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dc9334eed5a95313$var$_iconNew = $dc9334eed5a95313$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dc9334eed5a95313$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-left
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc9334eed5a95313$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $dc9334eed5a95313$var$_react.default.createElement($dc9334eed5a95313$var$_iconNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$dc9334eed5a95313$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $dc9334eed5a95313$var$_default = module.exports.default = $dc9334eed5a95313$var$ChevronLeftIcon;

});

parcelRegister("4THFE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2e0f32559f08f5bfd98787a43c1619>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390e2c9c8165fa46$var$_react = $390e2c9c8165fa46$var$_interopRequireDefault((parcelRequire("cozmU")));

var $390e2c9c8165fa46$var$_iconNew = $390e2c9c8165fa46$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $390e2c9c8165fa46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildWorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/child-work-items
 * Usage guidance:
 * Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390e2c9c8165fa46$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $390e2c9c8165fa46$var$_react.default.createElement($390e2c9c8165fa46$var$_iconNew.default, Object.assign({
        name: "ChildWorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.5 13.5h5V11h-5zm0-7h5V4h-5zm6.5.25C15 7.44 14.44 8 13.75 8h-5.5C7.56 8 7 7.44 7 6.75V6H2.5v5a.5.5 0 0 0 .5.5h4v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-5.5C7.56 15 7 14.44 7 13.75V13H3a2 2 0 0 1-2-2V1h1.5v3.5H7v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25z"/>`
    }, props));
$390e2c9c8165fa46$var$ChildWorkItemsIcon.displayName = 'ChildWorkItemsIcon';
var $390e2c9c8165fa46$var$_default = module.exports.default = $390e2c9c8165fa46$var$ChildWorkItemsIcon;

});

parcelRegister("gDx2k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a7f4603a3394939adafb491e3ee704e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1c9ea370bd5b955$var$_react = $c1c9ea370bd5b955$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c1c9ea370bd5b955$var$_iconNew = $c1c9ea370bd5b955$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c1c9ea370bd5b955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/panel-right
 * Usage guidance:
 * Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1c9ea370bd5b955$var$PanelRightIcon = (props)=>/*#__PURE__*/ $c1c9ea370bd5b955$var$_react.default.createElement($c1c9ea370bd5b955$var$_iconNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.25 4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 4z"/><path fill="currentcolor" fill-rule="evenodd" d="M14 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c1c9ea370bd5b955$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $c1c9ea370bd5b955$var$_default = module.exports.default = $c1c9ea370bd5b955$var$PanelRightIcon;

});

parcelRegister("8A5sV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0f79607c297097b57c9a91ab8adc6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f5ece34709da00$var$_react = $63f5ece34709da00$var$_interopRequireDefault((parcelRequire("cozmU")));

var $63f5ece34709da00$var$_iconNew = $63f5ece34709da00$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $63f5ece34709da00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/files
 * Usage guidance:
 * Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63f5ece34709da00$var$FilesIcon = (props)=>/*#__PURE__*/ $63f5ece34709da00$var$_react.default.createElement($63f5ece34709da00$var$_iconNew.default, Object.assign({
        name: "FilesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$63f5ece34709da00$var$FilesIcon.displayName = 'FilesIcon';
var $63f5ece34709da00$var$_default = module.exports.default = $63f5ece34709da00$var$FilesIcon;

});

parcelRegister("8LYsc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8da0453588db1ecd928d81f929e2bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66319b5ec431a19f$var$_react = $66319b5ec431a19f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66319b5ec431a19f$var$_iconNew = $66319b5ec431a19f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $66319b5ec431a19f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-vertical
 * Usage guidance:
 * Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66319b5ec431a19f$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $66319b5ec431a19f$var$_react.default.createElement($66319b5ec431a19f$var$_iconNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$66319b5ec431a19f$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $66319b5ec431a19f$var$_default = module.exports.default = $66319b5ec431a19f$var$DragHandleVerticalIcon;

});

parcelRegister("gC2EJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64841177977326ccd1f2b755f9ee3f4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c18241597a6d91d6$var$_react = $c18241597a6d91d6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c18241597a6d91d6$var$_iconNew = $c18241597a6d91d6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c18241597a6d91d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/edit
 * Usage guidance:
 * Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c18241597a6d91d6$var$EditIcon = (props)=>/*#__PURE__*/ $c18241597a6d91d6$var$_react.default.createElement($c18241597a6d91d6$var$_iconNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c18241597a6d91d6$var$EditIcon.displayName = 'EditIcon';
var $c18241597a6d91d6$var$_default = module.exports.default = $c18241597a6d91d6$var$EditIcon;

});

parcelRegister("4ezc2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::363ad103c09d1ad4a29a90276bbc91d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3153c4d9ff89c07e$var$_react = $3153c4d9ff89c07e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3153c4d9ff89c07e$var$_iconNew = $3153c4d9ff89c07e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3153c4d9ff89c07e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3153c4d9ff89c07e$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $3153c4d9ff89c07e$var$_react.default.createElement($3153c4d9ff89c07e$var$_iconNew.default, Object.assign({
        name: "AlignImageRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$3153c4d9ff89c07e$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $3153c4d9ff89c07e$var$_default = module.exports.default = $3153c4d9ff89c07e$var$AlignImageRightIcon;

});

parcelRegister("iaH8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd19492838c8bf6d2562d3c6e1f4b1c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3aa9f3e1b28ace3$var$_react = $d3aa9f3e1b28ace3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d3aa9f3e1b28ace3$var$_iconNew = $d3aa9f3e1b28ace3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d3aa9f3e1b28ace3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-bold
 * Usage guidance:
 * Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3aa9f3e1b28ace3$var$TextBoldIcon = (props)=>/*#__PURE__*/ $d3aa9f3e1b28ace3$var$_react.default.createElement($d3aa9f3e1b28ace3$var$_iconNew.default, Object.assign({
        name: "TextBoldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$d3aa9f3e1b28ace3$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $d3aa9f3e1b28ace3$var$_default = module.exports.default = $d3aa9f3e1b28ace3$var$TextBoldIcon;

});

parcelRegister("99F21", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c78712d633a3463bd40c9b97dadf0e09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aa4c85c2b3caf9d$var$_react = $6aa4c85c2b3caf9d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6aa4c85c2b3caf9d$var$_iconNew = $6aa4c85c2b3caf9d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $6aa4c85c2b3caf9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shrink-horizontal
 * Usage guidance:
 * Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aa4c85c2b3caf9d$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $6aa4c85c2b3caf9d$var$_react.default.createElement($6aa4c85c2b3caf9d$var$_iconNew.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$6aa4c85c2b3caf9d$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $6aa4c85c2b3caf9d$var$_default = module.exports.default = $6aa4c85c2b3caf9d$var$ShrinkHorizontalIcon;

});

parcelRegister("dimUV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4fb5985ea59ca2817ccd54e91e2500f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9adebba966103314$var$_react = $9adebba966103314$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9adebba966103314$var$_iconNew = $9adebba966103314$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9adebba966103314$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/decision
 * Usage guidance:
 * Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9adebba966103314$var$DecisionIcon = (props)=>/*#__PURE__*/ $9adebba966103314$var$_react.default.createElement($9adebba966103314$var$_iconNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$9adebba966103314$var$DecisionIcon.displayName = 'DecisionIcon';
var $9adebba966103314$var$_default = module.exports.default = $9adebba966103314$var$DecisionIcon;

});

parcelRegister("6m2p9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544012b3ed4fc4d2fd72613d04239f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a06a9aa05f3933d$var$_react = $4a06a9aa05f3933d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4a06a9aa05f3933d$var$_iconNew = $4a06a9aa05f3933d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4a06a9aa05f3933d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji
 * Usage guidance:
 * Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a06a9aa05f3933d$var$EmojiIcon = (props)=>/*#__PURE__*/ $4a06a9aa05f3933d$var$_react.default.createElement($4a06a9aa05f3933d$var$_iconNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$4a06a9aa05f3933d$var$EmojiIcon.displayName = 'EmojiIcon';
var $4a06a9aa05f3933d$var$_default = module.exports.default = $4a06a9aa05f3933d$var$EmojiIcon;

});

parcelRegister("dVbiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a7325677fe98dd4eea44aa4b991818a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2295d9ed0e8d999$var$_react = $a2295d9ed0e8d999$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a2295d9ed0e8d999$var$_iconNew = $a2295d9ed0e8d999$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $a2295d9ed0e8d999$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lightbulb
 * Usage guidance:
 * Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2295d9ed0e8d999$var$LightbulbIcon = (props)=>/*#__PURE__*/ $a2295d9ed0e8d999$var$_react.default.createElement($a2295d9ed0e8d999$var$_iconNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$a2295d9ed0e8d999$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $a2295d9ed0e8d999$var$_default = module.exports.default = $a2295d9ed0e8d999$var$LightbulbIcon;

});

parcelRegister("6NvYG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f608a9535844c97ef8ab19c5a3e36362>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f301fc919e785c5$var$_react = $4f301fc919e785c5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4f301fc919e785c5$var$_iconNew = $4f301fc919e785c5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4f301fc919e785c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/image
 * Usage guidance:
 * Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f301fc919e785c5$var$ImageIcon = (props)=>/*#__PURE__*/ $4f301fc919e785c5$var$_react.default.createElement($4f301fc919e785c5$var$_iconNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$4f301fc919e785c5$var$ImageIcon.displayName = 'ImageIcon';
var $4f301fc919e785c5$var$_default = module.exports.default = $4f301fc919e785c5$var$ImageIcon;

});

parcelRegister("kTw4V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57bb91851f2608c878b3bf5cfef0f2ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f361d3cad6c8e8b6$var$_react = $f361d3cad6c8e8b6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f361d3cad6c8e8b6$var$_iconNew = $f361d3cad6c8e8b6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f361d3cad6c8e8b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Maximize".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/maximize
 * Usage guidance:
 * Single purpose - Reserved for resizing screens, panels, modals, or media to its maximum size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f361d3cad6c8e8b6$var$MaximizeIcon = (props)=>/*#__PURE__*/ $f361d3cad6c8e8b6$var$_react.default.createElement($f361d3cad6c8e8b6$var$_iconNew.default, Object.assign({
        name: "MaximizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zm-2-.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM8 4H4.75a.75.75 0 0 0-.75.75V8h1.5V5.5H8zm2.5 6.5V8H12v3.25a.75.75 0 0 1-.75.75H8v-1.5z" clip-rule="evenodd"/>`
    }, props));
$f361d3cad6c8e8b6$var$MaximizeIcon.displayName = 'MaximizeIcon';
var $f361d3cad6c8e8b6$var$_default = module.exports.default = $f361d3cad6c8e8b6$var$MaximizeIcon;

});

parcelRegister("fodiz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b34369bc616a9ef3$var$_react = $b34369bc616a9ef3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b34369bc616a9ef3$var$_iconNew = $b34369bc616a9ef3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b34369bc616a9ef3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b34369bc616a9ef3$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $b34369bc616a9ef3$var$_react.default.createElement($b34369bc616a9ef3$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$b34369bc616a9ef3$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $b34369bc616a9ef3$var$_default = module.exports.default = $b34369bc616a9ef3$var$StatusInformationIcon;

});

parcelRegister("aHWpe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::266cfa8a244e6a03d3f71862db1654df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7cbb39bc7b9da06d$var$_react = $7cbb39bc7b9da06d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7cbb39bc7b9da06d$var$_iconNew = $7cbb39bc7b9da06d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7cbb39bc7b9da06d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-italic
 * Usage guidance:
 * Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7cbb39bc7b9da06d$var$TextItalicIcon = (props)=>/*#__PURE__*/ $7cbb39bc7b9da06d$var$_react.default.createElement($7cbb39bc7b9da06d$var$_iconNew.default, Object.assign({
        name: "TextItalicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$7cbb39bc7b9da06d$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $7cbb39bc7b9da06d$var$_default = module.exports.default = $7cbb39bc7b9da06d$var$TextItalicIcon;

});

parcelRegister("8AMT2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::016771fe6116559afc90969f7cd64cf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64179b65c49c7e58$var$_react = $64179b65c49c7e58$var$_interopRequireDefault((parcelRequire("cozmU")));

var $64179b65c49c7e58$var$_iconNew = $64179b65c49c7e58$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $64179b65c49c7e58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-right
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64179b65c49c7e58$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $64179b65c49c7e58$var$_react.default.createElement($64179b65c49c7e58$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h7.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-7.75C.615 15 0 14.384 0 13.625zm1.5.125v11H9v-11zM12 2.375C12 1.615 12.616 1 13.375 1h1.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1v-11z" clip-rule="evenodd"/>`
    }, props));
$64179b65c49c7e58$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $64179b65c49c7e58$var$_default = module.exports.default = $64179b65c49c7e58$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("6RqDx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f30f1ece100e9c6940f39e1796a26132>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fec5accf2b68381$var$_react = $4fec5accf2b68381$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4fec5accf2b68381$var$_iconNew = $4fec5accf2b68381$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4fec5accf2b68381$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-narrow
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fec5accf2b68381$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $4fec5accf2b68381$var$_react.default.createElement($4fec5accf2b68381$var$_iconNew.default, Object.assign({
        name: "ContentWidthNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5H2V1h12zm-10.5 3v5h9v-5zM3.375 4h9.25C13.385 4 14 4.616 14 5.375v5.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 12 2 11.384 2 10.625v-5.25C2 4.615 2.616 4 3.375 4M14 15H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$4fec5accf2b68381$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $4fec5accf2b68381$var$_default = module.exports.default = $4fec5accf2b68381$var$ContentWidthNarrowIcon;

});

parcelRegister("4mxZP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b906b7c624205e45ee60c81e60477bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32d3967706eb0e28$var$_react = $32d3967706eb0e28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $32d3967706eb0e28$var$_iconNew = $32d3967706eb0e28$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $32d3967706eb0e28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-wide
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32d3967706eb0e28$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $32d3967706eb0e28$var$_react.default.createElement($32d3967706eb0e28$var$_iconNew.default, Object.assign({
        name: "ContentWidthWideIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$32d3967706eb0e28$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $32d3967706eb0e28$var$_default = module.exports.default = $32d3967706eb0e28$var$ContentWidthWideIcon;

});

parcelRegister("fTKqO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb0d2797cf5666e2287eff3bcf39de93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b930026940db43e4$var$_react = $b930026940db43e4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b930026940db43e4$var$_iconNew = $b930026940db43e4$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b930026940db43e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-numbered
 * Usage guidance:
 * Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b930026940db43e4$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $b930026940db43e4$var$_react.default.createElement($b930026940db43e4$var$_iconNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$b930026940db43e4$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $b930026940db43e4$var$_default = module.exports.default = $b930026940db43e4$var$ListNumberedIcon;

});

parcelRegister("4bg4c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0fea9f03da224a46310c146a298b7987>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30b4a7055b26c03d$var$_react = $30b4a7055b26c03d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $30b4a7055b26c03d$var$_iconNew = $30b4a7055b26c03d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $30b4a7055b26c03d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up-right
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30b4a7055b26c03d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $30b4a7055b26c03d$var$_react.default.createElement($30b4a7055b26c03d$var$_iconNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$30b4a7055b26c03d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $30b4a7055b26c03d$var$_default = module.exports.default = $30b4a7055b26c03d$var$ArrowUpRightIcon;

});

parcelRegister("3H27T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cfb509a7f1979b2b736fe67208d0bad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b07097e5a4da29b$var$_react = $2b07097e5a4da29b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2b07097e5a4da29b$var$_iconNew = $2b07097e5a4da29b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2b07097e5a4da29b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-left
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b07097e5a4da29b$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $2b07097e5a4da29b$var$_react.default.createElement($2b07097e5a4da29b$var$_iconNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$2b07097e5a4da29b$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $2b07097e5a4da29b$var$_default = module.exports.default = $2b07097e5a4da29b$var$TextIndentLeftIcon;

});

parcelRegister("5ZtfK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45c9574e292cbffc$var$_react = $45c9574e292cbffc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $45c9574e292cbffc$var$_iconNew = $45c9574e292cbffc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $45c9574e292cbffc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45c9574e292cbffc$var$ClockIcon = (props)=>/*#__PURE__*/ $45c9574e292cbffc$var$_react.default.createElement($45c9574e292cbffc$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$45c9574e292cbffc$var$ClockIcon.displayName = 'ClockIcon';
var $45c9574e292cbffc$var$_default = module.exports.default = $45c9574e292cbffc$var$ClockIcon;

});

parcelRegister("9FyRG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0812cf7af63b42bd3bd830103e378223>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70a2fcd9877b6362$var$_react = $70a2fcd9877b6362$var$_interopRequireDefault((parcelRequire("cozmU")));

var $70a2fcd9877b6362$var$_iconNew = $70a2fcd9877b6362$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $70a2fcd9877b6362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-style
 * Usage guidance:
 * Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70a2fcd9877b6362$var$TextStyleIcon = (props)=>/*#__PURE__*/ $70a2fcd9877b6362$var$_react.default.createElement($70a2fcd9877b6362$var$_iconNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$70a2fcd9877b6362$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $70a2fcd9877b6362$var$_default = module.exports.default = $70a2fcd9877b6362$var$TextStyleIcon;

});

parcelRegister("kUFQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::135f4c7bdbceeb077cf9a8a8ded75f12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3997dbe20e85c88$var$_react = $f3997dbe20e85c88$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f3997dbe20e85c88$var$_iconNew = $f3997dbe20e85c88$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f3997dbe20e85c88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/undo
 * Usage guidance:
 * Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3997dbe20e85c88$var$UndoIcon = (props)=>/*#__PURE__*/ $f3997dbe20e85c88$var$_react.default.createElement($f3997dbe20e85c88$var$_iconNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$f3997dbe20e85c88$var$UndoIcon.displayName = 'UndoIcon';
var $f3997dbe20e85c88$var$_default = module.exports.default = $f3997dbe20e85c88$var$UndoIcon;

});

parcelRegister("8y86q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8acf1a27a91c9466d89ec39a50a9bc59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6397c8ba216d0a1f$var$_react = $6397c8ba216d0a1f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6397c8ba216d0a1f$var$_iconNew = $6397c8ba216d0a1f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $6397c8ba216d0a1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-broken
 * Usage guidance:
 * Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6397c8ba216d0a1f$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $6397c8ba216d0a1f$var$_react.default.createElement($6397c8ba216d0a1f$var$_iconNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$6397c8ba216d0a1f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $6397c8ba216d0a1f$var$_default = module.exports.default = $6397c8ba216d0a1f$var$LinkBrokenIcon;

});

parcelRegister("lMGh1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdbedf4cfdaceb49$var$_react = $fdbedf4cfdaceb49$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fdbedf4cfdaceb49$var$_iconNew = $fdbedf4cfdaceb49$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $fdbedf4cfdaceb49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdbedf4cfdaceb49$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $fdbedf4cfdaceb49$var$_react.default.createElement($fdbedf4cfdaceb49$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$fdbedf4cfdaceb49$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $fdbedf4cfdaceb49$var$_default = module.exports.default = $fdbedf4cfdaceb49$var$StatusWarningIcon;

});

parcelRegister("gMfOo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::040aca903d6f7f3a8ac64134909255c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c36d64ee8ff073a0$var$_react = $c36d64ee8ff073a0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c36d64ee8ff073a0$var$_iconNew = $c36d64ee8ff073a0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c36d64ee8ff073a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/flag
 * Usage guidance:
 * Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c36d64ee8ff073a0$var$FlagIcon = (props)=>/*#__PURE__*/ $c36d64ee8ff073a0$var$_react.default.createElement($c36d64ee8ff073a0$var$_iconNew.default, Object.assign({
        name: "FlagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$c36d64ee8ff073a0$var$FlagIcon.displayName = 'FlagIcon';
var $c36d64ee8ff073a0$var$_default = module.exports.default = $c36d64ee8ff073a0$var$FlagIcon;

});

parcelRegister("2hJf7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83aab1eaf1c12eec7924b955b15ac03b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1aa043935d92b47e$var$_react = $1aa043935d92b47e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1aa043935d92b47e$var$_iconNew = $1aa043935d92b47e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1aa043935d92b47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-closed
 * Usage guidance:
 * Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1aa043935d92b47e$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $1aa043935d92b47e$var$_react.default.createElement($1aa043935d92b47e$var$_iconNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1aa043935d92b47e$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $1aa043935d92b47e$var$_default = module.exports.default = $1aa043935d92b47e$var$FolderClosedIcon;

});

parcelRegister("gJ798", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d0e12c208abbb78a0f55c6c4c303feb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2d6646ee35b127c$var$_react = $c2d6646ee35b127c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c2d6646ee35b127c$var$_iconNew = $c2d6646ee35b127c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c2d6646ee35b127c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-bar
 * Usage guidance:
 * Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2d6646ee35b127c$var$ChartBarIcon = (props)=>/*#__PURE__*/ $c2d6646ee35b127c$var$_react.default.createElement($c2d6646ee35b127c$var$_iconNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$c2d6646ee35b127c$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $c2d6646ee35b127c$var$_default = module.exports.default = $c2d6646ee35b127c$var$ChartBarIcon;

});

parcelRegister("iRFKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c0c4ad146353612d795bc46242b9b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbbd90517f1842a4$var$_react = $dbbd90517f1842a4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dbbd90517f1842a4$var$_iconNew = $dbbd90517f1842a4$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dbbd90517f1842a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-item
 * Usage guidance:
 * Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbbd90517f1842a4$var$WorkItemIcon = (props)=>/*#__PURE__*/ $dbbd90517f1842a4$var$_react.default.createElement($dbbd90517f1842a4$var$_iconNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$dbbd90517f1842a4$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $dbbd90517f1842a4$var$_default = module.exports.default = $dbbd90517f1842a4$var$WorkItemIcon;

});

parcelRegister("1LOGx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a56ed314940e96507f3d40e0a0c01e78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14a17f393f83eb91$var$_react = $14a17f393f83eb91$var$_interopRequireDefault((parcelRequire("cozmU")));

var $14a17f393f83eb91$var$_iconNew = $14a17f393f83eb91$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $14a17f393f83eb91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/filter
 * Usage guidance:
 * Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14a17f393f83eb91$var$FilterIcon = (props)=>/*#__PURE__*/ $14a17f393f83eb91$var$_react.default.createElement($14a17f393f83eb91$var$_iconNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$14a17f393f83eb91$var$FilterIcon.displayName = 'FilterIcon';
var $14a17f393f83eb91$var$_default = module.exports.default = $14a17f393f83eb91$var$FilterIcon;

});

parcelRegister("60Yxm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d16ee7f193d7f9eccce76e7ab24df030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4611b393736d4022$var$_react = $4611b393736d4022$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4611b393736d4022$var$_iconNew = $4611b393736d4022$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4611b393736d4022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video
 * Usage guidance:
 * Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4611b393736d4022$var$VideoIcon = (props)=>/*#__PURE__*/ $4611b393736d4022$var$_react.default.createElement($4611b393736d4022$var$_iconNew.default, Object.assign({
        name: "VideoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$4611b393736d4022$var$VideoIcon.displayName = 'VideoIcon';
var $4611b393736d4022$var$_default = module.exports.default = $4611b393736d4022$var$VideoIcon;

});

parcelRegister("iITVA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1823cfe9afabe77ba419bd26f71a4aac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da17b823168f49ad$var$_react = $da17b823168f49ad$var$_interopRequireDefault((parcelRequire("cozmU")));

var $da17b823168f49ad$var$_iconNew = $da17b823168f49ad$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $da17b823168f49ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da17b823168f49ad$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $da17b823168f49ad$var$_react.default.createElement($da17b823168f49ad$var$_iconNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$da17b823168f49ad$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $da17b823168f49ad$var$_default = module.exports.default = $da17b823168f49ad$var$PersonAvatarIcon;

});

parcelRegister("2F2yY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f01661340debd3d$var$_react = $1f01661340debd3d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1f01661340debd3d$var$_iconNew = $1f01661340debd3d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1f01661340debd3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f01661340debd3d$var$ReleaseIcon = (props)=>/*#__PURE__*/ $1f01661340debd3d$var$_react.default.createElement($1f01661340debd3d$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$1f01661340debd3d$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $1f01661340debd3d$var$_default = module.exports.default = $1f01661340debd3d$var$ReleaseIcon;

});

parcelRegister("3cW6b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a489a34de812f994a428ba0205e7c45f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $255f8f494616b6c8$var$_react = $255f8f494616b6c8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $255f8f494616b6c8$var$_iconNew = $255f8f494616b6c8$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $255f8f494616b6c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-unlocked
 * Usage guidance:
 * Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $255f8f494616b6c8$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $255f8f494616b6c8$var$_react.default.createElement($255f8f494616b6c8$var$_iconNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$255f8f494616b6c8$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $255f8f494616b6c8$var$_default = module.exports.default = $255f8f494616b6c8$var$LockUnlockedIcon;

});

parcelRegister("krxYo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::322b41880f5a89d40242e9ba724a95a8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee20ae9e58b14598$var$_react = $ee20ae9e58b14598$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ee20ae9e58b14598$var$_iconNew = $ee20ae9e58b14598$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ee20ae9e58b14598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/globe
 * Usage guidance:
 * Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee20ae9e58b14598$var$GlobeIcon = (props)=>/*#__PURE__*/ $ee20ae9e58b14598$var$_react.default.createElement($ee20ae9e58b14598$var$_iconNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$ee20ae9e58b14598$var$GlobeIcon.displayName = 'GlobeIcon';
var $ee20ae9e58b14598$var$_default = module.exports.default = $ee20ae9e58b14598$var$GlobeIcon;

});

parcelRegister("4MdqE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43bf53b902c7760c7d34ab2f73c7faf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a60fd35ea374f5$var$_react = $37a60fd35ea374f5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $37a60fd35ea374f5$var$_iconNew = $37a60fd35ea374f5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $37a60fd35ea374f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/board
 * Usage guidance:
 * Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37a60fd35ea374f5$var$BoardIcon = (props)=>/*#__PURE__*/ $37a60fd35ea374f5$var$_react.default.createElement($37a60fd35ea374f5$var$_iconNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$37a60fd35ea374f5$var$BoardIcon.displayName = 'BoardIcon';
var $37a60fd35ea374f5$var$_default = module.exports.default = $37a60fd35ea374f5$var$BoardIcon;

});

parcelRegister("eleTd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::941c0b73ee4166f5fbd7d8255b8cba77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a70e93a195014f90$var$_react = $a70e93a195014f90$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a70e93a195014f90$var$_iconNew = $a70e93a195014f90$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $a70e93a195014f90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/department
 * Usage guidance:
 * Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a70e93a195014f90$var$DepartmentIcon = (props)=>/*#__PURE__*/ $a70e93a195014f90$var$_react.default.createElement($a70e93a195014f90$var$_iconNew.default, Object.assign({
        name: "DepartmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$a70e93a195014f90$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $a70e93a195014f90$var$_default = module.exports.default = $a70e93a195014f90$var$DepartmentIcon;

});

parcelRegister("6Fmj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78b6099804234b515b62cf480a885222>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4da7e00139770356$var$_react = $4da7e00139770356$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4da7e00139770356$var$_iconNew = $4da7e00139770356$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4da7e00139770356$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/download
 * Usage guidance:
 * Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4da7e00139770356$var$DownloadIcon = (props)=>/*#__PURE__*/ $4da7e00139770356$var$_react.default.createElement($4da7e00139770356$var$_iconNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$4da7e00139770356$var$DownloadIcon.displayName = 'DownloadIcon';
var $4da7e00139770356$var$_default = module.exports.default = $4da7e00139770356$var$DownloadIcon;

});

parcelRegister("ldb9Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58a0b7e350797ce13f4ff95adc3c91f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f713780c51866062$var$_react = $f713780c51866062$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f713780c51866062$var$_iconNew = $f713780c51866062$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f713780c51866062$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/email
 * Usage guidance:
 * Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f713780c51866062$var$EmailIcon = (props)=>/*#__PURE__*/ $f713780c51866062$var$_react.default.createElement($f713780c51866062$var$_iconNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f713780c51866062$var$EmailIcon.displayName = 'EmailIcon';
var $f713780c51866062$var$_default = module.exports.default = $f713780c51866062$var$EmailIcon;

});

parcelRegister("b35Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a86f4b205ac22b1546889eacd37f769a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80b495a1b59f8745$var$_react = $80b495a1b59f8745$var$_interopRequireDefault((parcelRequire("cozmU")));

var $80b495a1b59f8745$var$_iconNew = $80b495a1b59f8745$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $80b495a1b59f8745$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-add
 * Usage guidance:
 * Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80b495a1b59f8745$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $80b495a1b59f8745$var$_react.default.createElement($80b495a1b59f8745$var$_iconNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$80b495a1b59f8745$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $80b495a1b59f8745$var$_default = module.exports.default = $80b495a1b59f8745$var$EmojiAddIcon;

});

parcelRegister("jo8MM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::095c702cfaeb2dfd3bf1271951315acc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1d712e594d529e0$var$_react = $e1d712e594d529e0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e1d712e594d529e0$var$_iconNew = $e1d712e594d529e0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e1d712e594d529e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/premium
 * Usage guidance:
 * Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1d712e594d529e0$var$PremiumIcon = (props)=>/*#__PURE__*/ $e1d712e594d529e0$var$_react.default.createElement($e1d712e594d529e0$var$_iconNew.default, Object.assign({
        name: "PremiumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$e1d712e594d529e0$var$PremiumIcon.displayName = 'PremiumIcon';
var $e1d712e594d529e0$var$_default = module.exports.default = $e1d712e594d529e0$var$PremiumIcon;

});

parcelRegister("1WMy0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb0bea125dd8937d618f765cb0e5678>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16b0ddbe16535926$var$_react = $16b0ddbe16535926$var$_interopRequireDefault((parcelRequire("cozmU")));

var $16b0ddbe16535926$var$_iconNew = $16b0ddbe16535926$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $16b0ddbe16535926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/refresh
 * Usage guidance:
 * Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16b0ddbe16535926$var$RefreshIcon = (props)=>/*#__PURE__*/ $16b0ddbe16535926$var$_react.default.createElement($16b0ddbe16535926$var$_iconNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$16b0ddbe16535926$var$RefreshIcon.displayName = 'RefreshIcon';
var $16b0ddbe16535926$var$_default = module.exports.default = $16b0ddbe16535926$var$RefreshIcon;

});

parcelRegister("hz2oZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f79e038092c071ca070983f22750dcb0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc9791897a11f408$var$_react = $cc9791897a11f408$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cc9791897a11f408$var$_iconNew = $cc9791897a11f408$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $cc9791897a11f408$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/retry
 * Usage guidance:
 * Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc9791897a11f408$var$RetryIcon = (props)=>/*#__PURE__*/ $cc9791897a11f408$var$_react.default.createElement($cc9791897a11f408$var$_iconNew.default, Object.assign({
        name: "RetryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$cc9791897a11f408$var$RetryIcon.displayName = 'RetryIcon';
var $cc9791897a11f408$var$_default = module.exports.default = $cc9791897a11f408$var$RetryIcon;

});

parcelRegister("blZUD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::959808d0c396950308013c029859eefb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8441ae690db74055$var$_react = $8441ae690db74055$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8441ae690db74055$var$_iconNew = $8441ae690db74055$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8441ae690db74055$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/send
 * Usage guidance:
 * Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8441ae690db74055$var$SendIcon = (props)=>/*#__PURE__*/ $8441ae690db74055$var$_react.default.createElement($8441ae690db74055$var$_iconNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$8441ae690db74055$var$SendIcon.displayName = 'SendIcon';
var $8441ae690db74055$var$_default = module.exports.default = $8441ae690db74055$var$SendIcon;

});

parcelRegister("dflgH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e090651e87a4c0aa5c0215d940612c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a4d2c815e61d7c6$var$_react = $9a4d2c815e61d7c6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9a4d2c815e61d7c6$var$_iconNew = $9a4d2c815e61d7c6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9a4d2c815e61d7c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/teams
 * Usage guidance:
 * Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a4d2c815e61d7c6$var$TeamsIcon = (props)=>/*#__PURE__*/ $9a4d2c815e61d7c6$var$_react.default.createElement($9a4d2c815e61d7c6$var$_iconNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$9a4d2c815e61d7c6$var$TeamsIcon.displayName = 'TeamsIcon';
var $9a4d2c815e61d7c6$var$_default = module.exports.default = $9a4d2c815e61d7c6$var$TeamsIcon;

});

parcelRegister("jC4nA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e474f69ce8107d3e$var$_react = $e474f69ce8107d3e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e474f69ce8107d3e$var$_iconNew = $e474f69ce8107d3e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e474f69ce8107d3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e474f69ce8107d3e$var$AiAgentIcon = (props)=>/*#__PURE__*/ $e474f69ce8107d3e$var$_react.default.createElement($e474f69ce8107d3e$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$e474f69ce8107d3e$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $e474f69ce8107d3e$var$_default = module.exports.default = $e474f69ce8107d3e$var$AiAgentIcon;

});

parcelRegister("f0b2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd047031fc1ab3dc653f8f0d4a9b3992>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aebf6bcea32cc34f$var$_react = $aebf6bcea32cc34f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $aebf6bcea32cc34f$var$_iconNew = $aebf6bcea32cc34f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $aebf6bcea32cc34f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-generative-text-summary
 * Usage guidance:
 * Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aebf6bcea32cc34f$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $aebf6bcea32cc34f$var$_react.default.createElement($aebf6bcea32cc34f$var$_iconNew.default, Object.assign({
        name: "AiGenerativeTextSummaryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 12.5V14H1v-1.5zm3.5-5.25v1.5H1v-1.5zM15 2v1.5H1V2zm-2.5 7a.75.75 0 0 1 .71.49l.61 1.69 1.69.62a.75.75 0 0 1 .49.7l-.01.12a.75.75 0 0 1-.48.59l-1.69.61-.61 1.69a.75.75 0 0 1-.59.48l-.12.01a.75.75 0 0 1-.7-.49l-.61-1.69-1.69-.61a.75.75 0 0 1-.48-.59L9 12.5a.75.75 0 0 1 .49-.7l1.69-.61.62-1.69a.75.75 0 0 1 .59-.48z"/>`
    }, props));
$aebf6bcea32cc34f$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $aebf6bcea32cc34f$var$_default = module.exports.default = $aebf6bcea32cc34f$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("jmUhx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e19bbad3396d13e0$var$_react = $e19bbad3396d13e0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e19bbad3396d13e0$var$_iconNew = $e19bbad3396d13e0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e19bbad3396d13e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e19bbad3396d13e0$var$AppsIcon = (props)=>/*#__PURE__*/ $e19bbad3396d13e0$var$_react.default.createElement($e19bbad3396d13e0$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$e19bbad3396d13e0$var$AppsIcon.displayName = 'AppsIcon';
var $e19bbad3396d13e0$var$_default = module.exports.default = $e19bbad3396d13e0$var$AppsIcon;

});

parcelRegister("437ur", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed3e64ddc98c9818e2b632fa43be9778>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f2d409c0bda0032$var$_react = $2f2d409c0bda0032$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2f2d409c0bda0032$var$_iconNew = $2f2d409c0bda0032$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2f2d409c0bda0032$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/assets
 * Usage guidance:
 * Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f2d409c0bda0032$var$AssetsIcon = (props)=>/*#__PURE__*/ $2f2d409c0bda0032$var$_react.default.createElement($2f2d409c0bda0032$var$_iconNew.default, Object.assign({
        name: "AssetsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.487 2.013a1.75 1.75 0 1 0-2.474 2.474 1.75 1.75 0 0 0 2.474-2.474M.952.952A3.25 3.25 0 0 1 6.412 2.5H9.5V4H6.413a3.24 3.24 0 0 1-.865 1.548c-.442.442-.98.73-1.548.865V9.5H2.5V6.413A3.25 3.25 0 0 1 .952.953M10.5 3.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m3 3.25v3H12v-3zM1 12.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9.5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m-1 .75h-3V12h3z" clip-rule="evenodd"/>`
    }, props));
$2f2d409c0bda0032$var$AssetsIcon.displayName = 'AssetsIcon';
var $2f2d409c0bda0032$var$_default = module.exports.default = $2f2d409c0bda0032$var$AssetsIcon;

});

parcelRegister("745kV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da700306fe9346a3fbf34e0d7fc8a9b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524d0bd59360b490$var$_react = $524d0bd59360b490$var$_interopRequireDefault((parcelRequire("cozmU")));

var $524d0bd59360b490$var$_iconNew = $524d0bd59360b490$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $524d0bd59360b490$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Card".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/card
 * Usage guidance:
 * Known uses: Representing cards in Trello. Toggling card detail in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524d0bd59360b490$var$CardIcon = (props)=>/*#__PURE__*/ $524d0bd59360b490$var$_react.default.createElement($524d0bd59360b490$var$_iconNew.default, Object.assign({
        name: "CardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V9h11v4a.5.5 0 0 1-.5.5zm10.5-6h-11V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5zM4 12h5v-1.5H4zm6.5 0H12v-1.5h-1.5z" clip-rule="evenodd"/>`
    }, props));
$524d0bd59360b490$var$CardIcon.displayName = 'CardIcon';
var $524d0bd59360b490$var$_default = module.exports.default = $524d0bd59360b490$var$CardIcon;

});

parcelRegister("lCTy3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86e4cb0cec8e9e12166c70b4519c936c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbe83c4e5e02850c$var$_react = $fbe83c4e5e02850c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fbe83c4e5e02850c$var$_iconNew = $fbe83c4e5e02850c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $fbe83c4e5e02850c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/changes
 * Usage guidance:
 * Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fbe83c4e5e02850c$var$ChangesIcon = (props)=>/*#__PURE__*/ $fbe83c4e5e02850c$var$_react.default.createElement($fbe83c4e5e02850c$var$_iconNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$fbe83c4e5e02850c$var$ChangesIcon.displayName = 'ChangesIcon';
var $fbe83c4e5e02850c$var$_default = module.exports.default = $fbe83c4e5e02850c$var$ChangesIcon;

});

parcelRegister("1TvTa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98f19b4ce1cb01bc604b2707417d4c9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1613a9f3df2073e1$var$_react = $1613a9f3df2073e1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1613a9f3df2073e1$var$_iconNew = $1613a9f3df2073e1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1613a9f3df2073e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-trend-up
 * Usage guidance:
 * Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1613a9f3df2073e1$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $1613a9f3df2073e1$var$_react.default.createElement($1613a9f3df2073e1$var$_iconNew.default, Object.assign({
        name: "ChartTrendUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$1613a9f3df2073e1$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $1613a9f3df2073e1$var$_default = module.exports.default = $1613a9f3df2073e1$var$ChartTrendUpIcon;

});

parcelRegister("GErjr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a5273bf73a300c0a96580f2d60e5eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08034ace5a438205$var$_react = $08034ace5a438205$var$_interopRequireDefault((parcelRequire("cozmU")));

var $08034ace5a438205$var$_iconNew = $08034ace5a438205$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $08034ace5a438205$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clipboard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clipboard
 * Usage guidance:
 * Known uses: Pasting content from clipboard.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08034ace5a438205$var$ClipboardIcon = (props)=>/*#__PURE__*/ $08034ace5a438205$var$_react.default.createElement($08034ace5a438205$var$_iconNew.default, Object.assign({
        name: "ClipboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.563 1.5A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.937 1.5H12.5a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2zM4.5 3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75zm2-1.5A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$08034ace5a438205$var$ClipboardIcon.displayName = 'ClipboardIcon';
var $08034ace5a438205$var$_default = module.exports.default = $08034ace5a438205$var$ClipboardIcon;

});

parcelRegister("6Jphz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5082110311c830a8bcf9a83e01e518d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0143c87e5599b3d6$var$_react = $0143c87e5599b3d6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0143c87e5599b3d6$var$_iconNew = $0143c87e5599b3d6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $0143c87e5599b3d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-casual
 * Usage guidance:
 * Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0143c87e5599b3d6$var$EmojiCasualIcon = (props)=>/*#__PURE__*/ $0143c87e5599b3d6$var$_react.default.createElement($0143c87e5599b3d6$var$_iconNew.default, Object.assign({
        name: "EmojiCasualIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
    }, props));
$0143c87e5599b3d6$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var $0143c87e5599b3d6$var$_default = module.exports.default = $0143c87e5599b3d6$var$EmojiCasualIcon;

});

parcelRegister("bsSbN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ce65ba7869b0055f5705d33514c3585>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $858c5813c844811c$var$_react = $858c5813c844811c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $858c5813c844811c$var$_iconNew = $858c5813c844811c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $858c5813c844811c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open-strikethrough
 * Usage guidance:
 * Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $858c5813c844811c$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $858c5813c844811c$var$_react.default.createElement($858c5813c844811c$var$_iconNew.default, Object.assign({
        name: "EyeOpenStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$858c5813c844811c$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $858c5813c844811c$var$_default = module.exports.default = $858c5813c844811c$var$EyeOpenStrikethroughIcon;

});

parcelRegister("6CsCB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d79300678d2a12fe66aec1aaa52c9d3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d1c7e55bb9d1743$var$_react = $4d1c7e55bb9d1743$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4d1c7e55bb9d1743$var$_iconNew = $4d1c7e55bb9d1743$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4d1c7e55bb9d1743$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/goal
 * Usage guidance:
 * Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d1c7e55bb9d1743$var$GoalIcon = (props)=>/*#__PURE__*/ $4d1c7e55bb9d1743$var$_react.default.createElement($4d1c7e55bb9d1743$var$_iconNew.default, Object.assign({
        name: "GoalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$4d1c7e55bb9d1743$var$GoalIcon.displayName = 'GoalIcon';
var $4d1c7e55bb9d1743$var$_default = module.exports.default = $4d1c7e55bb9d1743$var$GoalIcon;

});

parcelRegister("58BEn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::708dbab3c1b17a398665c72c78e75a68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bdae7acd5ceb747$var$_react = $3bdae7acd5ceb747$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3bdae7acd5ceb747$var$_iconNew = $3bdae7acd5ceb747$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3bdae7acd5ceb747$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Highlight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/highlight
 * Usage guidance:
 * Single purpose - Reserved for highlight text tool in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bdae7acd5ceb747$var$HighlightIcon = (props)=>/*#__PURE__*/ $3bdae7acd5ceb747$var$_react.default.createElement($3bdae7acd5ceb747$var$_iconNew.default, Object.assign({
        name: "HighlightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.516.31a1.375 1.375 0 0 1 1.76.155l1.259 1.26c.471.47.537 1.212.155 1.759L9.365 9.679a.75.75 0 0 1-.363.277l-3.5 1.25a.75.75 0 0 1-.782-.176l-.095-.094-.595.594a.75.75 0 0 1-1.06 0l-.5-.5a.75.75 0 0 1 0-1.06l.594-.595-.094-.095a.75.75 0 0 1-.176-.782l1.25-3.5a.75.75 0 0 1 .277-.363zm.773 1.29L5.913 5.353l2.734 2.734L12.4 2.71zM7.382 8.942 5.058 6.618l-.692 1.937 1.079 1.08z" clip-rule="evenodd"/>`
    }, props));
$3bdae7acd5ceb747$var$HighlightIcon.displayName = 'HighlightIcon';
var $3bdae7acd5ceb747$var$_default = module.exports.default = $3bdae7acd5ceb747$var$HighlightIcon;

});

parcelRegister("i7DLA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c95e3b2b5922216d1b08416f0f7380e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d317ba3ae99b936a$var$_react = $d317ba3ae99b936a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d317ba3ae99b936a$var$_iconNew = $d317ba3ae99b936a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d317ba3ae99b936a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageFullscreen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-fullscreen
 * Usage guidance:
 * Reserved for viewing an image in a fullscreen view or modal.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d317ba3ae99b936a$var$ImageFullscreenIcon = (props)=>/*#__PURE__*/ $d317ba3ae99b936a$var$_react.default.createElement($d317ba3ae99b936a$var$_iconNew.default, Object.assign({
        name: "ImageFullscreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 1.5H5V0H1.375C.615 0 0 .616 0 1.375V5h1.5zM3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h.633l2.892-3.719a1.375 1.375 0 0 1 1.927-.244l1.048.81V5a.5.5 0 0 0-.5-.5zm6.5 5.743L9.633 8.801l-2.1 2.699H11a.5.5 0 0 0 .5-.5zM16 11v3.625c0 .76-.616 1.375-1.375 1.375H11v-1.5h3.5V11z" clip-rule="evenodd"/><path fill="currentcolor" d="M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d317ba3ae99b936a$var$ImageFullscreenIcon.displayName = 'ImageFullscreenIcon';
var $d317ba3ae99b936a$var$_default = module.exports.default = $d317ba3ae99b936a$var$ImageFullscreenIcon;

});

parcelRegister("bVwWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::558c104ff8faf5b48aac0a9ed58ae604>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8aee9393389c7e72$var$_react = $8aee9393389c7e72$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8aee9393389c7e72$var$_iconNew = $8aee9393389c7e72$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8aee9393389c7e72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-inline
 * Usage guidance:
 * Reserved for representing inline images in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8aee9393389c7e72$var$ImageInlineIcon = (props)=>/*#__PURE__*/ $8aee9393389c7e72$var$_react.default.createElement($8aee9393389c7e72$var$_iconNew.default, Object.assign({
        name: "ImageInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6.375C0 5.615.616 5 1.375 5h3.25C5.385 5 6 5.616 6 6.375v3.25C6 10.385 5.384 11 4.625 11h-3.25C.615 11 0 10.384 0 9.625zm1.5.125v3h3v-3zM16 8.75H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$8aee9393389c7e72$var$ImageInlineIcon.displayName = 'ImageInlineIcon';
var $8aee9393389c7e72$var$_default = module.exports.default = $8aee9393389c7e72$var$ImageInlineIcon;

});

parcelRegister("ipvL3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::272e3b8843112479f54c710862304c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6733243002bd244$var$_react = $d6733243002bd244$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d6733243002bd244$var$_iconNew = $d6733243002bd244$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d6733243002bd244$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/incident
 * Usage guidance:
 * Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6733243002bd244$var$IncidentIcon = (props)=>/*#__PURE__*/ $d6733243002bd244$var$_react.default.createElement($d6733243002bd244$var$_iconNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$d6733243002bd244$var$IncidentIcon.displayName = 'IncidentIcon';
var $d6733243002bd244$var$_default = module.exports.default = $d6733243002bd244$var$IncidentIcon;

});

parcelRegister("2hwiA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b3a7d8a72332e603fef2266fe30ca4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a963929695c5edc$var$_react = $1a963929695c5edc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1a963929695c5edc$var$_iconNew = $1a963929695c5edc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1a963929695c5edc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-checklist
 * Usage guidance:
 * Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a963929695c5edc$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $1a963929695c5edc$var$_react.default.createElement($1a963929695c5edc$var$_iconNew.default, Object.assign({
        name: "ListChecklistIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L0 11.53l1.26-.81.81 1.25 2.35-2.94zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L0 4.03l1.26-.81.81 1.25 2.35-2.94zM16.01 11v1.5h-9V11zm0-7.5V5h-9V3.5z"/>`
    }, props));
$1a963929695c5edc$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $1a963929695c5edc$var$_default = module.exports.default = $1a963929695c5edc$var$ListChecklistIcon;

});

parcelRegister("cFvoT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89b2e97288972fd78f0b507371cecac4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9391abd79e84a727$var$_react = $9391abd79e84a727$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9391abd79e84a727$var$_iconNew = $9391abd79e84a727$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9391abd79e84a727$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/magic-wand
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9391abd79e84a727$var$MagicWandIcon = (props)=>/*#__PURE__*/ $9391abd79e84a727$var$_react.default.createElement($9391abd79e84a727$var$_iconNew.default, Object.assign({
        name: "MagicWandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$9391abd79e84a727$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $9391abd79e84a727$var$_default = module.exports.default = $9391abd79e84a727$var$MagicWandIcon;

});

parcelRegister("f3HCt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98a7fb9d1f8215942557835e8fe15757>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af68f8bc24bb40c9$var$_react = $af68f8bc24bb40c9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $af68f8bc24bb40c9$var$_iconNew = $af68f8bc24bb40c9$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $af68f8bc24bb40c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/megaphone
 * Usage guidance:
 * Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af68f8bc24bb40c9$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $af68f8bc24bb40c9$var$_react.default.createElement($af68f8bc24bb40c9$var$_iconNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$af68f8bc24bb40c9$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $af68f8bc24bb40c9$var$_default = module.exports.default = $af68f8bc24bb40c9$var$MegaphoneIcon;

});

parcelRegister("lW3nu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::094fe57c93517a6ea39f3973813cfaec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff81a287556e81e8$var$_react = $ff81a287556e81e8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ff81a287556e81e8$var$_iconNew = $ff81a287556e81e8$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ff81a287556e81e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin
 * Usage guidance:
 * Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff81a287556e81e8$var$PinIcon = (props)=>/*#__PURE__*/ $ff81a287556e81e8$var$_react.default.createElement($ff81a287556e81e8$var$_iconNew.default, Object.assign({
        name: "PinIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$ff81a287556e81e8$var$PinIcon.displayName = 'PinIcon';
var $ff81a287556e81e8$var$_default = module.exports.default = $ff81a287556e81e8$var$PinIcon;

});

parcelRegister("6omt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57f9542d992ed1d533edfe2b8ecaa13f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a766965044ed7ba$var$_react = $4a766965044ed7ba$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4a766965044ed7ba$var$_iconNew = $4a766965044ed7ba$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $4a766965044ed7ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/presenter-mode
 * Usage guidance:
 * Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a766965044ed7ba$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $4a766965044ed7ba$var$_react.default.createElement($4a766965044ed7ba$var$_iconNew.default, Object.assign({
        name: "PresenterModeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$4a766965044ed7ba$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $4a766965044ed7ba$var$_default = module.exports.default = $4a766965044ed7ba$var$PresenterModeIcon;

});

parcelRegister("7EFpK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0e2f4aa13758d0bfd9dbdbb60ec6216>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0170332ce105524d$var$_react = $0170332ce105524d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0170332ce105524d$var$_iconNew = $0170332ce105524d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $0170332ce105524d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/problem
 * Usage guidance:
 * Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0170332ce105524d$var$ProblemIcon = (props)=>/*#__PURE__*/ $0170332ce105524d$var$_react.default.createElement($0170332ce105524d$var$_iconNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m.562 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.692-.561a6.5 6.5 0 0 0-8.632-.5l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$0170332ce105524d$var$ProblemIcon.displayName = 'ProblemIcon';
var $0170332ce105524d$var$_default = module.exports.default = $0170332ce105524d$var$ProblemIcon;

});

parcelRegister("iFXu4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9008592011ce9e8020afead221c92f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d98a329ef066b307$var$_react = $d98a329ef066b307$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d98a329ef066b307$var$_iconNew = $d98a329ef066b307$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d98a329ef066b307$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/project
 * Usage guidance:
 * Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d98a329ef066b307$var$ProjectIcon = (props)=>/*#__PURE__*/ $d98a329ef066b307$var$_react.default.createElement($d98a329ef066b307$var$_iconNew.default, Object.assign({
        name: "ProjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$d98a329ef066b307$var$ProjectIcon.displayName = 'ProjectIcon';
var $d98a329ef066b307$var$_default = module.exports.default = $d98a329ef066b307$var$ProjectIcon;

});

parcelRegister("9KPiA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b16f37d6eeb68cc92423d4c88632d59d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71a033d1a48a88c5$var$_react = $71a033d1a48a88c5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $71a033d1a48a88c5$var$_iconNew = $71a033d1a48a88c5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $71a033d1a48a88c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ProjectionScreen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/projection-screen
 * Usage guidance:
 * Multi purpose - Intended usages: Presentation mode.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71a033d1a48a88c5$var$ProjectionScreenIcon = (props)=>/*#__PURE__*/ $71a033d1a48a88c5$var$_react.default.createElement($71a033d1a48a88c5$var$_iconNew.default, Object.assign({
        name: "ProjectionScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3.5H0V2h16v1.5h-1V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.904l-2.65 3.111-1.142-.972L4.376 12H3a2 2 0 0 1-2-2zm1.5 0V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3.5z" clip-rule="evenodd"/>`
    }, props));
$71a033d1a48a88c5$var$ProjectionScreenIcon.displayName = 'ProjectionScreenIcon';
var $71a033d1a48a88c5$var$_default = module.exports.default = $71a033d1a48a88c5$var$ProjectionScreenIcon;

});

parcelRegister("bLfHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c19cab1662745293e5bf052395df909>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $890043e1635e8bc0$var$_react = $890043e1635e8bc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $890043e1635e8bc0$var$_iconNew = $890043e1635e8bc0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $890043e1635e8bc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/rovo-chat
 * Usage guidance:
 * Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $890043e1635e8bc0$var$RovoChatIcon = (props)=>/*#__PURE__*/ $890043e1635e8bc0$var$_react.default.createElement($890043e1635e8bc0$var$_iconNew.default, Object.assign({
        name: "RovoChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
    }, props));
$890043e1635e8bc0$var$RovoChatIcon.displayName = 'RovoChatIcon';
var $890043e1635e8bc0$var$_default = module.exports.default = $890043e1635e8bc0$var$RovoChatIcon;

});

parcelRegister("jxqsh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98b08a2b870f3c3b50ef8171323529a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3959ed9b82c4230$var$_react = $e3959ed9b82c4230$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e3959ed9b82c4230$var$_iconNew = $e3959ed9b82c4230$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e3959ed9b82c4230$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shapes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shapes
 * Usage guidance:
 * Single purpose - Reserved for shapes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3959ed9b82c4230$var$ShapesIcon = (props)=>/*#__PURE__*/ $e3959ed9b82c4230$var$_react.default.createElement($e3959ed9b82c4230$var$_iconNew.default, Object.assign({
        name: "ShapesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.38C15 1.62 14.38 1 13.63 1h-3.25C9.62 1 9 1.62 9 2.38v3.25C9 6.39 9.62 7 10.38 7h3.25C14.39 7 15 6.38 15 5.63zm-1.5.13v3h-3v-3zM3.13 1.26a1 1 0 0 1 1.74 0l2.57 4.5a1 1 0 0 1-.87 1.5H1.43a1 1 0 0 1-.87-1.5zM4 2.76 2.29 5.75h3.42zM.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M4 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M10 9h4.25a.75.75 0 0 1 .75.75V14h-1.5v-2.44l-3.72 3.72-1.06-1.06 3.72-3.72H10z" clip-rule="evenodd"/>`
    }, props));
$e3959ed9b82c4230$var$ShapesIcon.displayName = 'ShapesIcon';
var $e3959ed9b82c4230$var$_default = module.exports.default = $e3959ed9b82c4230$var$ShapesIcon;

});

parcelRegister("foj7F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::91eb3cc88ce44a200106439f98b1c931>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b347ee4103462e57$var$_react = $b347ee4103462e57$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b347ee4103462e57$var$_iconNew = $b347ee4103462e57$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b347ee4103462e57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-embed
 * Usage guidance:
 * Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b347ee4103462e57$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $b347ee4103462e57$var$_react.default.createElement($b347ee4103462e57$var$_iconNew.default, Object.assign({
        name: "SmartLinkEmbedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$b347ee4103462e57$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $b347ee4103462e57$var$_default = module.exports.default = $b347ee4103462e57$var$SmartLinkEmbedIcon;

});

parcelRegister("3PHGt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc3dca90319e7388db9e2dce4ed3d07c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ca805415c461dc6$var$_react = $2ca805415c461dc6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2ca805415c461dc6$var$_iconNew = $2ca805415c461dc6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2ca805415c461dc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-list
 * Usage guidance:
 * Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ca805415c461dc6$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $2ca805415c461dc6$var$_react.default.createElement($2ca805415c461dc6$var$_iconNew.default, Object.assign({
        name: "SmartLinkListIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$2ca805415c461dc6$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $2ca805415c461dc6$var$_default = module.exports.default = $2ca805415c461dc6$var$SmartLinkListIcon;

});

parcelRegister("4R9Nm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07f197be0bf4c2b3f61c32ad2572b521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3893b5cad40ffc02$var$_react = $3893b5cad40ffc02$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3893b5cad40ffc02$var$_iconNew = $3893b5cad40ffc02$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3893b5cad40ffc02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-descending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3893b5cad40ffc02$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $3893b5cad40ffc02$var$_react.default.createElement($3893b5cad40ffc02$var$_iconNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$3893b5cad40ffc02$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $3893b5cad40ffc02$var$_default = module.exports.default = $3893b5cad40ffc02$var$SortDescendingIcon;

});

parcelRegister("iDtkd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9aea886ae883664b6f933ff09352e51d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9129dd563822422$var$_react = $d9129dd563822422$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d9129dd563822422$var$_iconNew = $d9129dd563822422$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d9129dd563822422$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-discovery
 * Usage guidance:
 * Reserved for discovery statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9129dd563822422$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $d9129dd563822422$var$_react.default.createElement($d9129dd563822422$var$_iconNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$d9129dd563822422$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $d9129dd563822422$var$_default = module.exports.default = $d9129dd563822422$var$StatusDiscoveryIcon;

});

parcelRegister("d2UzA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a30433b8c1a1c3a667f8e0f7f3e98c0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97f7588189ff552a$var$_react = $97f7588189ff552a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $97f7588189ff552a$var$_iconNew = $97f7588189ff552a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $97f7588189ff552a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-verified
 * Usage guidance:
 * Reserved for representing verified content.
 * Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97f7588189ff552a$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $97f7588189ff552a$var$_react.default.createElement($97f7588189ff552a$var$_iconNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$97f7588189ff552a$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $97f7588189ff552a$var$_default = module.exports.default = $97f7588189ff552a$var$StatusVerifiedIcon;

});

parcelRegister("jrU5N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e54e25b96851fc60bdb723a0652ff9cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e28c0cb72f38b2d1$var$_react = $e28c0cb72f38b2d1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e28c0cb72f38b2d1$var$_iconNew = $e28c0cb72f38b2d1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e28c0cb72f38b2d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/story
 * Usage guidance:
 * Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e28c0cb72f38b2d1$var$StoryIcon = (props)=>/*#__PURE__*/ $e28c0cb72f38b2d1$var$_react.default.createElement($e28c0cb72f38b2d1$var$_iconNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$e28c0cb72f38b2d1$var$StoryIcon.displayName = 'StoryIcon';
var $e28c0cb72f38b2d1$var$_default = module.exports.default = $e28c0cb72f38b2d1$var$StoryIcon;

});

parcelRegister("fxA94", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b21529f89f7d042240b8c37cbada8167>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b505f9c52d1b6714$var$_react = $b505f9c52d1b6714$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b505f9c52d1b6714$var$_iconNew = $b505f9c52d1b6714$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b505f9c52d1b6714$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-large
 * Usage guidance:
 * Reserved for representing thick border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b505f9c52d1b6714$var$StrokeWeightLargeIcon = (props)=>/*#__PURE__*/ $b505f9c52d1b6714$var$_react.default.createElement($b505f9c52d1b6714$var$_iconNew.default, Object.assign({
        name: "StrokeWeightLargeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>`
    }, props));
$b505f9c52d1b6714$var$StrokeWeightLargeIcon.displayName = 'StrokeWeightLargeIcon';
var $b505f9c52d1b6714$var$_default = module.exports.default = $b505f9c52d1b6714$var$StrokeWeightLargeIcon;

});

parcelRegister("53Mds", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6901c67cca80c8242be2d93fe8d4eb3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af2a24398360f15$var$_react = $3af2a24398360f15$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3af2a24398360f15$var$_iconNew = $3af2a24398360f15$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3af2a24398360f15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-split
 * Usage guidance:
 * Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3af2a24398360f15$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $3af2a24398360f15$var$_react.default.createElement($3af2a24398360f15$var$_iconNew.default, Object.assign({
        name: "TableCellSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$3af2a24398360f15$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $3af2a24398360f15$var$_default = module.exports.default = $3af2a24398360f15$var$TableCellSplitIcon;

});

parcelRegister("jWZGH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e99802f2e737020f4d265f3fccc6feba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e86348facefda14a$var$_react = $e86348facefda14a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e86348facefda14a$var$_iconNew = $e86348facefda14a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e86348facefda14a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-left
 * Usage guidance:
 * Reserved for adding a table column to the left of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e86348facefda14a$var$TableColumnAddLeftIcon = (props)=>/*#__PURE__*/ $e86348facefda14a$var$_react.default.createElement($e86348facefda14a$var$_iconNew.default, Object.assign({
        name: "TableColumnAddLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.75 8.75V11h-1.5V8.75H0v-1.5h2.25V5h1.5v2.25H6v1.5z" clip-rule="evenodd"/>`
    }, props));
$e86348facefda14a$var$TableColumnAddLeftIcon.displayName = 'TableColumnAddLeftIcon';
var $e86348facefda14a$var$_default = module.exports.default = $e86348facefda14a$var$TableColumnAddLeftIcon;

});

parcelRegister("eehur", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d25eddbd59369a4dc35dfe0ed526458c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5bff0a597e42035$var$_react = $a5bff0a597e42035$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a5bff0a597e42035$var$_iconNew = $a5bff0a597e42035$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $a5bff0a597e42035$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-right
 * Usage guidance:
 * Reserved for adding a table column to the right of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5bff0a597e42035$var$TableColumnAddRightIcon = (props)=>/*#__PURE__*/ $a5bff0a597e42035$var$_react.default.createElement($a5bff0a597e42035$var$_iconNew.default, Object.assign({
        name: "TableColumnAddRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.25 6.25V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5z" clip-rule="evenodd"/>`
    }, props));
$a5bff0a597e42035$var$TableColumnAddRightIcon.displayName = 'TableColumnAddRightIcon';
var $a5bff0a597e42035$var$_default = module.exports.default = $a5bff0a597e42035$var$TableColumnAddRightIcon;

});

parcelRegister("iMVfw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f88c9202ad41652af953a050b1c0148>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dad91e390f716c62$var$_react = $dad91e390f716c62$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dad91e390f716c62$var$_iconNew = $dad91e390f716c62$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dad91e390f716c62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-left
 * Usage guidance:
 * Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dad91e390f716c62$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $dad91e390f716c62$var$_react.default.createElement($dad91e390f716c62$var$_iconNew.default, Object.assign({
        name: "TableColumnMoveLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$dad91e390f716c62$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $dad91e390f716c62$var$_default = module.exports.default = $dad91e390f716c62$var$TableColumnMoveLeftIcon;

});

parcelRegister("eh9HJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1dc8de20280b4683a2b844103e1b1c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a64a2e4c0db04afe$var$_react = $a64a2e4c0db04afe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a64a2e4c0db04afe$var$_iconNew = $a64a2e4c0db04afe$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $a64a2e4c0db04afe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-columns-distribute
 * Usage guidance:
 * Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a64a2e4c0db04afe$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $a64a2e4c0db04afe$var$_react.default.createElement($a64a2e4c0db04afe$var$_iconNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$a64a2e4c0db04afe$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $a64a2e4c0db04afe$var$_default = module.exports.default = $a64a2e4c0db04afe$var$TableColumnsDistributeIcon;

});

parcelRegister("jJItz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd7ac2615482fa596dfe409d6ad2a75c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5e4b84ec19b31a3$var$_react = $e5e4b84ec19b31a3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e5e4b84ec19b31a3$var$_iconNew = $e5e4b84ec19b31a3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e5e4b84ec19b31a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddAbove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-above
 * Usage guidance:
 * Reserved for adding a table row above the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5e4b84ec19b31a3$var$TableRowAddAboveIcon = (props)=>/*#__PURE__*/ $e5e4b84ec19b31a3$var$_react.default.createElement($e5e4b84ec19b31a3$var$_iconNew.default, Object.assign({
        name: "TableRowAddAboveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm6.25-7.25H11v-1.5H8.75V0h-1.5v2.25H5v1.5h2.25V6h1.5z" clip-rule="evenodd"/>`
    }, props));
$e5e4b84ec19b31a3$var$TableRowAddAboveIcon.displayName = 'TableRowAddAboveIcon';
var $e5e4b84ec19b31a3$var$_default = module.exports.default = $e5e4b84ec19b31a3$var$TableRowAddAboveIcon;

});

parcelRegister("i8vym", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::088f872458a9690a9677799fea659be0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d34173237534d28c$var$_react = $d34173237534d28c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d34173237534d28c$var$_iconNew = $d34173237534d28c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d34173237534d28c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-below
 * Usage guidance:
 * Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d34173237534d28c$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $d34173237534d28c$var$_react.default.createElement($d34173237534d28c$var$_iconNew.default, Object.assign({
        name: "TableRowAddBelowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$d34173237534d28c$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $d34173237534d28c$var$_default = module.exports.default = $d34173237534d28c$var$TableRowAddBelowIcon;

});

parcelRegister("kSpvN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6658efa410614a3df4d5545c16ea7387>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32ca3ee0050ad2f$var$_react = $f32ca3ee0050ad2f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f32ca3ee0050ad2f$var$_iconNew = $f32ca3ee0050ad2f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f32ca3ee0050ad2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-up
 * Usage guidance:
 * Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32ca3ee0050ad2f$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $f32ca3ee0050ad2f$var$_react.default.createElement($f32ca3ee0050ad2f$var$_iconNew.default, Object.assign({
        name: "TableRowMoveUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$f32ca3ee0050ad2f$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $f32ca3ee0050ad2f$var$_default = module.exports.default = $f32ca3ee0050ad2f$var$TableRowMoveUpIcon;

});

parcelRegister("3CdTA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a62a428af43647937a5cadad3158597>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a1fb31103b70aa6$var$_react = $2a1fb31103b70aa6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2a1fb31103b70aa6$var$_iconNew = $2a1fb31103b70aa6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2a1fb31103b70aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextShorten".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-shorten
 * Usage guidance:
 * Reserved for shortening text content with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a1fb31103b70aa6$var$TextShortenIcon = (props)=>/*#__PURE__*/ $2a1fb31103b70aa6$var$_react.default.createElement($2a1fb31103b70aa6$var$_iconNew.default, Object.assign({
        name: "TextShortenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zM8 11H1V9.5h7z" clip-rule="evenodd"/>`
    }, props));
$2a1fb31103b70aa6$var$TextShortenIcon.displayName = 'TextShortenIcon';
var $2a1fb31103b70aa6$var$_default = module.exports.default = $2a1fb31103b70aa6$var$TextShortenIcon;

});

parcelRegister("74BSk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666c8d62169507f981045087d75a2fbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5266495938a03e91$var$_react = $5266495938a03e91$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5266495938a03e91$var$_iconNew = $5266495938a03e91$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $5266495938a03e91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSpellcheck".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-spellcheck
 * Usage guidance:
 * Single purpose - Reserved for spellchecking.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5266495938a03e91$var$TextSpellcheckIcon = (props)=>/*#__PURE__*/ $5266495938a03e91$var$_react.default.createElement($5266495938a03e91$var$_iconNew.default, Object.assign({
        name: "TextSpellcheckIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.67.494A.75.75 0 0 1 5.375 0h.75a.75.75 0 0 1 .705.494l3.625 10a.8.8 0 0 1 .045.256V11H9.06l-.015.006L9.043 11H9v-.118L7.955 8h-4.41L2.5 10.882V11h-.043l-.002.006L2.44 11H1v-.25a.8.8 0 0 1 .045-.256zM4.088 6.5h3.324L5.75 1.916z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m13.928 9.265 1.144.97-4.667 5.5a.75.75 0 0 1-1.144 0l-2.333-2.75 1.144-.97 1.761 2.076z" clip-rule="evenodd"/>`
    }, props));
$5266495938a03e91$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
var $5266495938a03e91$var$_default = module.exports.default = $5266495938a03e91$var$TextSpellcheckIcon;

});

parcelRegister("dwAVI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb536940475a84529fdd1d2bdcae7e65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d8ae90c4a3478ed$var$_react = $9d8ae90c4a3478ed$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9d8ae90c4a3478ed$var$_iconNew = $9d8ae90c4a3478ed$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9d8ae90c4a3478ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-wrap
 * Usage guidance:
 * Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d8ae90c4a3478ed$var$TextWrapIcon = (props)=>/*#__PURE__*/ $9d8ae90c4a3478ed$var$_react.default.createElement($9d8ae90c4a3478ed$var$_iconNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$9d8ae90c4a3478ed$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $9d8ae90c4a3478ed$var$_default = module.exports.default = $9d8ae90c4a3478ed$var$TextWrapIcon;

});

parcelRegister("bDjVc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::572305b998c439047b1ac624fa78e28b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8782ca378307a44b$var$_react = $8782ca378307a44b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8782ca378307a44b$var$_iconNew = $8782ca378307a44b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8782ca378307a44b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/whiteboard
 * Usage guidance:
 * Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8782ca378307a44b$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $8782ca378307a44b$var$_react.default.createElement($8782ca378307a44b$var$_iconNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$8782ca378307a44b$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $8782ca378307a44b$var$_default = module.exports.default = $8782ca378307a44b$var$WhiteboardIcon;

});

parcelRegister("1bzO2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4b5199968c77c410bc3ba67797e3d10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dd297d79338a70e$var$_react = $0dd297d79338a70e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0dd297d79338a70e$var$_iconNew = $0dd297d79338a70e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $0dd297d79338a70e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table
 * Usage guidance:
 * Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dd297d79338a70e$var$TableIcon = (props)=>/*#__PURE__*/ $0dd297d79338a70e$var$_react.default.createElement($0dd297d79338a70e$var$_iconNew.default, Object.assign({
        name: "TableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$0dd297d79338a70e$var$TableIcon.displayName = 'TableIcon';
var $0dd297d79338a70e$var$_default = module.exports.default = $0dd297d79338a70e$var$TableIcon;

});

parcelRegister("4w5V7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d362688fe90963dfa36937bc3153cc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $349ebe372beeaba0$var$_react = $349ebe372beeaba0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $349ebe372beeaba0$var$_iconNew = $349ebe372beeaba0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $349ebe372beeaba0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSparkle".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-sparkle
 * Usage guidance:
 * Reserved for representing AI-powered features and functionality.
 * 
 * Note: The "Editions" gem icon has replaced the sparkle icon for representing premium features in upsell experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $349ebe372beeaba0$var$AiSparkleIcon = (props)=>/*#__PURE__*/ $349ebe372beeaba0$var$_react.default.createElement($349ebe372beeaba0$var$_iconNew.default, Object.assign({
        name: "AiSparkleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 11.5V13H16v1.5h-1.5V16H13v-1.5h-1.5V13H13v-1.5zM8 1c.31 0 .587.19.7.479l1.63 4.19 4.192 1.632a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.192a.75.75 0 0 1-1.398 0L5.67 10.33 1.479 8.7a.75.75 0 0 1 0-1.398l4.19-1.631L7.301 1.48l.05-.104A.75.75 0 0 1 8 1M6.95 6.521a.75.75 0 0 1-.429.428L3.82 8l2.702 1.05a.75.75 0 0 1 .428.429l1.05 2.7 1.05-2.7.033-.073a.75.75 0 0 1 .396-.355L12.179 8l-2.7-1.05a.75.75 0 0 1-.428-.429L8 3.82zM3 0v1.5h1.5V3H3v1.5H1.5V3H0V1.5h1.5V0z"/>`
    }, props));
$349ebe372beeaba0$var$AiSparkleIcon.displayName = 'AiSparkleIcon';
var $349ebe372beeaba0$var$_default = module.exports.default = $349ebe372beeaba0$var$AiSparkleIcon;

});


$parcel$global.rlb("6wr18")
//# sourceMappingURL=vendors~editor_icon.7490f8e7.js.map
